// source: pbtypes/gen/cellular_sim_configs/sim_slot.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_sim_config_src_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_config_src_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_config_src_pb);
var pbtypes_gen_cellular_sim_configs_sim_config_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_config_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_config_pb);
var pbtypes_gen_cellular_sim_configs_sim_state_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_state_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_state_pb);
goog.exportSymbol('proto.cellular_sim_configs.SimSlot', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.SimSlot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cellular_sim_configs.SimSlot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.SimSlot.displayName = 'proto.cellular_sim_configs.SimSlot';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.SimSlot.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.SimSlot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.SimSlot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimSlot.toObject = function(includeInstance, msg) {
  var f, obj = {
iccid: jspb.Message.getFieldWithDefault(msg, 1, ""),
imsi: jspb.Message.getFieldWithDefault(msg, 2, ""),
mcc: jspb.Message.getFieldWithDefault(msg, 3, ""),
mnc: jspb.Message.getFieldWithDefault(msg, 4, ""),
simState: jspb.Message.getFieldWithDefault(msg, 5, 0),
simConfig: (f = msg.getSimConfig()) && pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.toObject(includeInstance, f),
simConfigSrc: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.SimSlot}
 */
proto.cellular_sim_configs.SimSlot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.SimSlot;
  return proto.cellular_sim_configs.SimSlot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.SimSlot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.SimSlot}
 */
proto.cellular_sim_configs.SimSlot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIccid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImsi(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMcc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMnc(value);
      break;
    case 5:
      var value = /** @type {!proto.cellular_sim_configs.SimState.Enum} */ (reader.readEnum());
      msg.setSimState(value);
      break;
    case 6:
      var value = new pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.deserializeBinaryFromReader);
      msg.setSimConfig(value);
      break;
    case 7:
      var value = /** @type {!proto.cellular_sim_configs.SimConfigSrc.Enum} */ (reader.readEnum());
      msg.setSimConfigSrc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.SimSlot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.SimSlot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.SimSlot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimSlot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImsi();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMcc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMnc();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSimState();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSimConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.serializeBinaryToWriter
    );
  }
  f = message.getSimConfigSrc();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string iccid = 1;
 * @return {string}
 */
proto.cellular_sim_configs.SimSlot.prototype.getIccid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setIccid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string imsi = 2;
 * @return {string}
 */
proto.cellular_sim_configs.SimSlot.prototype.getImsi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setImsi = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mcc = 3;
 * @return {string}
 */
proto.cellular_sim_configs.SimSlot.prototype.getMcc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setMcc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mnc = 4;
 * @return {string}
 */
proto.cellular_sim_configs.SimSlot.prototype.getMnc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setMnc = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SimState.Enum sim_state = 5;
 * @return {!proto.cellular_sim_configs.SimState.Enum}
 */
proto.cellular_sim_configs.SimSlot.prototype.getSimState = function() {
  return /** @type {!proto.cellular_sim_configs.SimState.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cellular_sim_configs.SimState.Enum} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setSimState = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional SimConfig sim_config = 6;
 * @return {?proto.cellular_sim_configs.SimConfig}
 */
proto.cellular_sim_configs.SimSlot.prototype.getSimConfig = function() {
  return /** @type{?proto.cellular_sim_configs.SimConfig} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig, 6));
};


/**
 * @param {?proto.cellular_sim_configs.SimConfig|undefined} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
*/
proto.cellular_sim_configs.SimSlot.prototype.setSimConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.clearSimConfig = function() {
  return this.setSimConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimSlot.prototype.hasSimConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SimConfigSrc.Enum sim_config_src = 7;
 * @return {!proto.cellular_sim_configs.SimConfigSrc.Enum}
 */
proto.cellular_sim_configs.SimSlot.prototype.getSimConfigSrc = function() {
  return /** @type {!proto.cellular_sim_configs.SimConfigSrc.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.cellular_sim_configs.SimConfigSrc.Enum} value
 * @return {!proto.cellular_sim_configs.SimSlot} returns this
 */
proto.cellular_sim_configs.SimSlot.prototype.setSimConfigSrc = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


goog.object.extend(exports, proto.cellular_sim_configs);
